import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';
import { Observable } from 'rxjs';

@Injectable()
export class TourOperatorService {
    constructor(private apiHttp: ApiHttp) {
    }

    public getTourOperatorsForCombo(messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminTourOperator/GetTourOperatorsForCombo', null, messageService);
    }

    public getTourOperatorsForComboByManagerId(messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminTourOperator/GetTourOperatorsForComboByManagerId', null, messageService);
    }

    public getTourBookings(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminTourOperator/GetTourBookings', data, messageService);
    }

    public getBookingById(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminTourOperator/GetBookingById', data, messageService);
    }

    public updateBookingStatus(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminTourOperator/UpdateBookingStatus', data, messageService);
    }

    public exportBookings(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.postDownloadFile('api/AdminTourOperator/ExportBookings', data, messageService);
    }

    public getOperators(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminTourOperator/GetOperators', data, messageService);
    }

    public getOperatorById(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminTourOperator/GetOperatorById', data, messageService);
    }

    public applyAction(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminTourOperator/ApplyAction', data, messageService);
    }

    public addTourOperator(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminTourOperator/AddTourOperator', data, messageService);
    }

    public updateTourOperator(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminTourOperator/UpdateTourOperator', data, messageService);
    }

    public uploadTourOperatorsXlsToDb(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminTourOperator/UploadTourOperatorsXlsToDb', data, messageService);
    }

    public getTourOperatorsTemplate(data: any): Observable<any> {
        return this.apiHttp.postObservable('api/AdminTourOperator/GetTourOperatorsTemplate', data);
    }
}
